import { spacing } from '@rbilabs/universal-components/themes';
import { StyleSheet, Text, View } from 'react-native';

import { primitive } from 'styles/constants/primitives';

import { MenuAcceleratorBadgeSvg } from './menu-accelerator-badge-svg';
import { BonusType, BonusTypes } from './types';

interface IMenuAcceleratorBadgePDP {
  bonusPoints: number;
  pointsMultiplier: number;
}

export const MenuAcceleratorBadgePDP = ({
  bonusPoints,
  pointsMultiplier,
}: IMenuAcceleratorBadgePDP) => {
  const bonusType: BonusType = bonusPoints ? BonusTypes.BONUS_POINTS : BonusTypes.POINTS_MULTIPLIER;
  const promotionMessage = `Get ${
    bonusType === BonusTypes.BONUS_POINTS ? `+${bonusPoints}` : `${pointsMultiplier}x`
  } Crowns`;

  return (
    <View style={styles.container}>
      <View style={styles.badge}>
        <MenuAcceleratorBadgeSvg />
        <Text>{promotionMessage}</Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: spacing.$4,
  },
  badge: {
    flexDirection: 'row',
    backgroundColor: primitive.bk.$meltyYellow,
    paddingHorizontal: spacing.$2,
    paddingVertical: spacing['$0.5'],
    borderRadius: 4,
    alignItems: 'center',
  },
});
